export enum FullOfferStatusEnum
{
  All = 0,
  Pending,
  Successful,
  Unsuccessful
}
